import apiClient from './api';
import {
  OverallScoresData,
  PerformanceHistoryResponse,
  ResonanceRankingYearData,
  CreativeVsMediaSeries,
  OverallScoresParams,
  PerformanceAcrossTimeParams,
  ResonanceRankingParams,
  CreativeVsMediaParams,
} from '@/types/socialResonance.types';

export const getOverallScores = async (params: OverallScoresParams): Promise<OverallScoresData> => {
  const { tenant_code, brand_id, ...queryParams } = params;
  const endpoint = `/social-resonance/${encodeURIComponent(tenant_code)}/overall/${encodeURIComponent(brand_id)}`;
  const response = await apiClient.get<OverallScoresData>(endpoint, { params: queryParams });
  return response.data;
};

export const getPerformanceAcrossTime = async (
  params: PerformanceAcrossTimeParams
): Promise<PerformanceHistoryResponse> => {
  const { tenant_code, brand_id, ...queryParams } = params;
  const response = await apiClient.get<PerformanceHistoryResponse>(
    `/social-resonance/${encodeURIComponent(tenant_code)}/performance-history/${encodeURIComponent(brand_id)}`,
    { params: queryParams }
  );
  return response.data;
};

export const getResonanceRanking = async (
  params: ResonanceRankingParams
): Promise<ResonanceRankingYearData[]> => {
  const { tenant_code, ...queryParams } = params;
  const endpoint = `/social-resonance/${encodeURIComponent(tenant_code)}/ranking`;
  const response = await apiClient.get<ResonanceRankingYearData[]>(endpoint, {
    params: queryParams,
  });
  return response.data;
};

export const getCreativeVsMedia = async (
  params: CreativeVsMediaParams
): Promise<CreativeVsMediaSeries[]> => {
  const { tenant_code, ...queryParams } = params;
  const endpoint = `/social-resonance/${encodeURIComponent(tenant_code)}/creative-vs-media`;
  const response = await apiClient.get<CreativeVsMediaSeries[]>(endpoint, {
    params: queryParams,
  });
  return response.data;
};
